import { AccessType } from './access-type.enum';

/**
 * Authorization metadata for routes (route.data)
 * Defines access requirements for protected routes
 * Authorization is based solely on requiredPermissionKey - permissions are derived from user roles
 */
export interface RouteAuthorizationData {
  /**
   * Required permission key for the route (usually *.Page)
   * If set, user must have this permission with appropriate access level
   */
  requiredPermissionKey?: string;

  /**
   * Minimum required access level
   * Default: Read (if requiredPermissionKey is set)
   */
  requiredAccess?: AccessType;
}

/**
 * Extended route configuration with authorization metadata
 */
export interface AuthorizedRoute {
  path: string;
  data?: RouteAuthorizationData;
  // ... other fields from Route
}
